export default "__VITE_ASSET__C1quJB36__"